module.exports = __webpack_public_path__ + "media/assets/faria_products/Cambridge IGCSE's-05f006694ea024c2e3399658c215d11b293069df120a25dfdfce87e94cb6ca4c.svg";